import { render, staticRenderFns } from "./MPopupRequest.vue?vue&type=template&id=d9064e04&"
import script from "./MPopupRequest.vue?vue&type=script&lang=ts&"
export * from "./MPopupRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports